import { render, staticRenderFns } from "./selectCode.vue?vue&type=template&id=96379066&"
import script from "./selectCode.vue?vue&type=script&lang=ts&"
export * from "./selectCode.vue?vue&type=script&lang=ts&"
import style0 from "./selectCode.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports